module.exports = __webpack_public_path__ + "1de9a0b393d9553ff00aae0a1b7d7783.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/name-male-5.svg
// module id = 91
// module chunks = 0